import { damPlayer } from "./video/dam";

const trackVideos = (container) => {
  if (!container) return;
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function() {
      const track =  container.querySelector(".fancybox__track");
      if (track) {
        const videoElements = container.querySelectorAll('video');

        videoElements.forEach(video => {
          damPlayer(video);
        });

        observer.disconnect();
      }
    });
  })
  observer.observe(container, { childList: true });
}

export {
    trackVideos
}